export function LogoMark({ size = 36 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 120 120" fill="none" aria-hidden="true" data-testid="logo-mark">
            {/* alarm bells */}
            <circle cx="29" cy="27" r="12" fill="#1E3FA3" />
            <circle cx="91" cy="27" r="12" fill="#1E3FA3" />
            {/* top knob */}
            <rect x="54" y="16" width="12" height="13" rx="4.5" fill="#1E3FA3" />
            {/* clock ring */}
            <circle cx="60" cy="68" r="38" stroke="#1E3FA3" strokeWidth="9" fill="#FFFFFF" />
            {/* legs */}
            <path d="M40 102 L33 113" stroke="#1E3FA3" strokeWidth="9" strokeLinecap="round" />
            <path d="M80 102 L87 113" stroke="#1E3FA3" strokeWidth="9" strokeLinecap="round" />
            {/* red cross */}
            <rect x="52" y="44" width="16" height="48" rx="3.5" fill="#E23E3E" />
            <rect x="36" y="60" width="48" height="16" rx="3.5" fill="#E23E3E" />
            {/* green check */}
            <path d="M44 70 L56 82 L82 50" stroke="#3CB371" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
    );
}

export function Logo({ size = 34 }) {
    return (
        <span className="flex items-center gap-3" data-testid="brand-logo">
            <LogoMark size={size} />
            <span className="font-extrabold text-xl tracking-tight text-ink">Med Check Alarm</span>
        </span>
    );
}
